module.exports = __webpack_public_path__ + "media/images/login/demo_btn_ov-30e599e28750f2c3e6a8c2e9b2cc6a74.png";